import httpStore from "@/api/httpStore.js";

export function updateShipstationCarriersAndServices() {
  return httpStore
    .get("shipping/update_carriers_and_services")
    .then(res => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
}
